<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <SelectorCaducidad></SelectorCaducidad>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import SelectorCaducidad from '../components/SelectorCaducidad.vue';
export default {
    name: 'ExpirationView',
    components: {
        ColumnaIzquierda,
        SelectorCaducidad,
    }
}
</script>